/**
 * Supported language codes for Unicode digit conversion
 */
export type UnicodeLangKeys = 'en' | 'ar' | 'fa';

const languageStartCodes: Record<UnicodeLangKeys, number> = {
  en: 48,
  ar: 1632,
  fa: 1776,
};

const SEARCH_REGEX = /[0-9٠-٩۰-۹]/g;

/**
 * Converts numbers between different Unicode digit representations
 */
export function convertDigits(str: string, toLanguage: UnicodeLangKeys): string {
  if (!str || str.trim() === '') return str;
  const toLangZeroCode = languageStartCodes[toLanguage];
  
  return str.replace(SEARCH_REGEX, (char) => {
    const code = char.charCodeAt(0);
    let digit = 0;
    if (code >= 48 && code <= 57) digit = code - 48;
    else if (code >= 1632 && code <= 1641) digit = code - 1632;
    else if (code >= 1776 && code <= 1785) digit = code - 1776;
    
    return String.fromCharCode(toLangZeroCode + digit);
  });
}
